import {
  BRAND_ICON_L,
  BRAND_ICON_VIEWBOX,
  BRAND_STROKE_WIDTH,
} from "./brand-icon.path.ts";

/** Marque Ligam — L stylisé. */
export function AppLogoMark({
  size = 18,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={BRAND_ICON_VIEWBOX}
      fill="none"
      className={className}
      aria-hidden
    >
      <path
        d={BRAND_ICON_L}
        stroke="currentColor"
        strokeWidth={BRAND_STROKE_WIDTH}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
